import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createManager,
  deleteManager,
  getAllManagers,
  updateManager,
} from "services/managerSlice";

export const fetchManagers = createAsyncThunk(
  "manager/fetchManagers",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const data = await getAllManagers(page, limit);
      console.log(data.data.data);
      return data.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addManager = createAsyncThunk(
  "manager/addManager",
  async (managerData, thunkAPI) => {
    try {
      console.log(managerData);
      const data = await createManager(managerData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const editManager = createAsyncThunk(
  "manager/editManager",
  async ({ id, managerData }, thunkAPI) => {
    try {
      const data = await updateManager(id, managerData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeManager = createAsyncThunk(
  "manager/removeManager",
  async (id, thunkAPI) => {
    try {
      await deleteManager(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  managers: [],
  total: 0,
  totalPages: 1,
  currentPage: 1,
  loading: false,
  error: null,
};

const managerSlice = createSlice({
  name: "manager",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchManagers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManagers.fulfilled, (state, action) => {
        state.loading = false;
        state.managers = action.payload.items || [];
        state.total = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.totalPages = action.payload.totalPages || 1;
      })

      .addCase(fetchManagers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add
      .addCase(addManager.fulfilled, (state, action) => {
        state.managers.unshift(action.payload);
      })

      // Edit
      .addCase(editManager.fulfilled, (state, action) => {
        state.managers = state.managers.map((manager) =>
          manager.id === action.payload.id ? action.payload : manager
        );
      })

      // Delete
      .addCase(removeManager.fulfilled, (state, action) => {
        state.managers = state.managers.filter(
          (manager) => manager.id !== action.payload
        );
      });
  },
});

export default managerSlice.reducer;
